module.exports = __webpack_public_path__ + "img/illustration_magic_null@2x.36aecd21.png";